module.exports = __webpack_public_path__ + "img/logo-italiansped.e7f2bf03.png";